module.exports = __webpack_public_path__ + "static/img/rabbit.832457d2.png";